import styled from "styled-components";

export const ConsoleDisabledUsersPageContainer = styled.div`
  max-width: 62.5rem;
  margin: 0 auto;
  width: 100%;
  padding: 1rem;

  overflow-x: auto;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  #dispatch-welcome-email {
    display: flex;
    background-color: transparent;
    border: none;

    .loader {
      margin-left: 0.25rem;
    }
  }

  [data-active="true"] {
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  }
`;

export const HeaderSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;

  height: 100%;

  button {
    padding: 0;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  input {
    padding-left: 40px;

    width: 350px;
    padding-left: 2.5rem;
  }
`;
